import { QueryObserverBaseResult, useQuery } from "react-query";
import api from "../../client";
import { queryKeys } from "../../query";
import { SkillListResponseData } from "../../types/skill";

export const getData = async () => {
  const { data } = await api.get<SkillListResponseData>(`/skills`);

  return data;
};

export const useSkills = (): QueryObserverBaseResult<SkillListResponseData> => {
  const { data, ...props } = useQuery(queryKeys.skills(), () => getData());
  return { data, ...props };
};
